import { Flex, Text } from "@chakra-ui/react";
import React from "react";

import AILoading from "../../../components/LoadingIndicator/AILoading";

type CreateLoadingProps = {
  autoCreateGuide?: boolean;
};

export const CreateLoading: React.FC<CreateLoadingProps> = ({
  autoCreateGuide = true,
}) => {
  return (
    <Flex alignItems="center" direction="column" mt="8" mb="72px">
      <AILoading />
      <Text fontSize="lg" fontWeight="500" my="2">
        {autoCreateGuide
          ? "Generating AI interview plan..."
          : "Creating AI interviewer..."}
      </Text>
      {autoCreateGuide && (
        <Text fontSize="md" fontWeight="400" color="gray.500">
          This will take around 20 seconds.
        </Text>
      )}
    </Flex>
  );
};
